import mitt from "mitt";
import type { ToastConfig } from "@jfrog-ba/vue-ui-core";

export type NotificationType = "success" | "warning" | "error" | "info";

export type JfToastEvents = {
  show: { type: NotificationType; config: ToastConfig };
  closeAll: void;
};

// Module-level singleton transport. It lets callers trigger toasts from any
// context (axios interceptors, services, router guards) without calling
// useToast(), which would require an active component setup for inject().
export const jfToastEmitter = mitt<JfToastEvents>();
